"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deriveNativeScriptHash = void 0;
const errors_1 = require("../errors");
const internal_1 = require("../types/internal");
const public_1 = require("../types/public");
const utils_1 = require("../utils");
const getVersion_1 = require("./getVersion");
const nativeScript_1 = require("./serialization/nativeScript");
const send = (params) => (Object.assign({ ins: 18 }, params));
function* deriveScriptHash_startComplexScript(script) {
    yield send({
        p1: 1,
        p2: 0,
        data: nativeScript_1.serializeComplexNativeScriptStart(script),
        expectedResponseLength: 0,
    });
}
function* deriveNativeScriptHash_addSimpleScript(script) {
    yield send({
        p1: 2,
        p2: 0,
        data: nativeScript_1.serializeSimpleNativeScript(script),
        expectedResponseLength: 0,
    });
}
function isComplexScript(script) {
    switch (script.type) {
        case public_1.NativeScriptType.ALL:
        case public_1.NativeScriptType.ANY:
        case public_1.NativeScriptType.N_OF_K:
            return true;
        default:
            return false;
    }
}
function* deriveNativeScriptHash_addScript(script) {
    if (isComplexScript(script)) {
        yield* deriveScriptHash_startComplexScript(script);
        for (const subscript of script.params.scripts) {
            yield* deriveNativeScriptHash_addScript(subscript);
        }
    }
    else {
        return yield* deriveNativeScriptHash_addSimpleScript(script);
    }
}
function* deriveNativeScriptHash_finishWholeNativeScript(displayFormat) {
    const response = yield send({
        p1: 3,
        p2: 0,
        data: nativeScript_1.serializeWholeNativeScriptFinish(displayFormat),
        expectedResponseLength: internal_1.NATIVE_SCRIPT_HASH_LENGTH,
    });
    return {
        scriptHashHex: response.toString("hex"),
    };
}
function ensureScriptHashDerivationSupportedByAppVersion(version) {
    if (!getVersion_1.getCompatibility(version).supportsNativeScriptHashDerivation) {
        throw new errors_1.DeviceVersionUnsupported(`Native script hash derivation not supported by Ledger app version ${utils_1.getVersionString(version)}.`);
    }
}
function* deriveNativeScriptHash(version, script, displayFormat) {
    getVersion_1.ensureLedgerAppVersionCompatible(version);
    ensureScriptHashDerivationSupportedByAppVersion(version);
    yield* deriveNativeScriptHash_addScript(script);
    const { scriptHashHex } = yield* deriveNativeScriptHash_finishWholeNativeScript(displayFormat);
    return {
        scriptHashHex,
    };
}
exports.deriveNativeScriptHash = deriveNativeScriptHash;
//# sourceMappingURL=data:application/json;base64,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